(function($, _) {
  var ns = window.nspace("ccc.viz.shared.views");

  /**
   * Toggles the visibility of the change indicator/location windowshade.
   */
  ns.WindowshadeView = Backbone.View.extend({
    /**
     * Using the main content container as our container.
     * This probably should be narrowed in scope, but it's
     * big enough to encompass other areas.
     */
    el: ".main-content-container",

    initialize: function(options) {
      this.model.on("hrefChanged", this.collapse, this);
      _.bindAll(this);
    },

    events: {
      "click button.change-indicator-link-cancel": "collapse",
      "click button.change-indicator-link": "expand"
    },

    expand: function() {
      this.$shade.height(this.$tabs.height());
      this.$tabContainer.fadeTo(750, 0, this.animateExpand);
    },

    animateExpand: function() {
      this.$shade.show().animate({ height: 500 }, 800);

      this.$indicatorContainer.fadeTo(750, 1);
    },

    collapse: function() {
      this.$indicatorContainer.fadeTo(750, 0);
      this.$shade.animate(
        { height: this.$tabs.height() },
        {
          duration: 800,
          always: this.animateCollapse
        }
      );
    },

    animateCollapse: function() {
      this.$shade.hide();
      this.$tabContainer.fadeTo(750, 1);
    },

    $shade: $(".dc-menu__shade"),
    $tabs: $(".map-table-tab-content"),
    $tabContainer: $(".tab-container"),
    $indicatorContainer: $(".indicator-container")
  });
})(jQuery, _);
